module.exports = __webpack_public_path__ + "static/media/arrow-small.3f7009b4.svg";